import { render } from "./HistoryReviewDetail.vue?vue&type=template&id=4ef61e10"
import script from "./HistoryReviewDetail.vue?vue&type=script&lang=js"
export * from "./HistoryReviewDetail.vue?vue&type=script&lang=js"

import "./HistoryReviewDetail.vue?vue&type=style&index=0&id=4ef61e10&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__